import notification from '../../notification'

export default {
  data() {
      return{
        registerAgreementsControl: null
      }
  },

  computed: {
    registerAgreements() {
      return this.$store.state.agreements.registerAgreements
    },
    agreements() {
      return this.$store.state.agreements.agreements
    },
  },
  mounted() {
     this.getAgreements()
  },

  methods: {
    getAgreements() {
      this.$vs.loading()
      this.$store.dispatch('agreements/getAgreements')
        .then( ()=>{
          this.getRegisterAgreements()
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    getRegisterAgreements() {
      this.$vs.loading()
      this.$store.dispatch('agreements/getRegisterAgreements')
        .then(() =>
          this.setAgreementsRegisterValue()
        )
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    setRegisterAgreements () {
      this.$vs.loading()
      let registerAgreementsArray = []
      Object.entries(this.registerAgreementsControl).forEach(([key, value]) => value ? registerAgreementsArray.push(key) : null);
      const payload = {
        agreements: registerAgreementsArray
      }
      this.$store.dispatch('agreements/setRegisterAgreements', payload)
        .then((response) => {
           this.$vs.notify(notification.success('Zapisano!'))
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
      .finally(() => {
          this.$vs.loading.close()
        })
    },
    setAgreementsRegisterValue () {
      this.registerAgreementsControl={}
      this.agreements.map(a => {
        this.registerAgreementsControl[a.uuid] = this.registerAgreements.find(ra => ra.uuid === a.uuid) != undefined ? true : false
      })
    },
  }
}
